import { ReactElement, ReactNode } from 'react';

import { Link, LinkSize } from '@dreryk/react-components';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../../translations';

const t = patientConsentsAndAuthorizationsTranslationKeys.consentsAndAuthorizations.table.actions;

type AddConsentOrAuthorizationLinkProps = { readonly icon?: ReactNode; readonly onClick: VoidFunction };

export const AddConsentOrAuthorizationLink = (props: AddConsentOrAuthorizationLinkProps): ReactElement => {
   return (
      <Link
         testId={'addConsentOrAuthorization'}
         label={t.addConsentOrAuthorization}
         icon={props.icon}
         size={LinkSize.NORMAL}
         onClick={props.onClick}
      />
   );
};
